import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

import ViewSettingsDialog from "src/modal/ViewSettingsDialog";
import EditSettingsDialog from "src/modal/EditSettingsDialog";
import { get, put } from "src/utils/networkUtils";
import AppSettingsTable from "src/components/app-settings/AppSettingsTable";

export default function AppSettingsPage() {
  const [, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [settings, setSettings] = useState(null);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [updateSettings, setUpdateSettings] = useState(null);
  // const [xpLevelSettings, setXpLevelSettings] = useState(null);
  // const [openXpUpdateDialog, setOpenXpUpdateDialog] = useState(false);
  // const [updateXpSettings, setUpdateXpSettings] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewSettings] = useState({
    settingsType: "",
    settings: "",
  });

  useEffect(() => {
    get(`/admin/app-settings`).then(function (response) {
      setRows(response.setingsTypes);
      setSettings(response.settings);
    });

    // get(`/admin/xp-level-settings`).then(function (response) {
    //   setXpLevelSettings(response.settings);
    // });
  }, []);

  const updateSettingsHandler = () => {
    setLoading(true);
    setOpenUpdateDialog(false);
    put(`/admin/app-settings`, updateSettings).then(function () {
      window.location.reload(true);
    });
  };
  const handleOpenUpdateDialog = (settingsType) => {
    const typeSettings = settings.find(
      (item) => item.settingsType === settingsType
    );
    const defaultSettings = Array.from({ length: 7 }, (_, i) => ({
      day: i + 1,
      amount: 20,
    }));

    setUpdateSettings({
      settingsType,
      settings: JSON.stringify(
        typeSettings?.settings
          ? JSON.parse(typeSettings.settings)
          : defaultSettings,
        null,
        2
      ),
    });

    setOpenUpdateDialog(true);
  };

  // const handleOpenXpUpdateDialog = (levelData) => {
  //   setUpdateXpSettings({
  //     ...levelData,
  //     settings: levelData.settings ? JSON.stringify(levelData.settings) : "{}",
  //   });
  //   setOpenXpUpdateDialog(true);
  // };

  return (
    <>
      <Helmet>
        <title> App Settings </title>
      </Helmet>

      <AppSettingsTable
        rows={rows}
        settings={settings}
        handleOpenUpdateDialog={handleOpenUpdateDialog}
      />

      {/* <XpLevelSettingsTable
        xpLevelSettings={xpLevelSettings}
        handleEdit={handleOpenXpUpdateDialog}
      /> */}

      <ViewSettingsDialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        settingsType={viewSettings.settingsType}
        settings={viewSettings.settings}
      />

      {openUpdateDialog && (
        <EditSettingsDialog
          open={openUpdateDialog}
          onClose={() => setOpenUpdateDialog(false)}
          updateSettings={updateSettings}
          setUpdateSettings={setUpdateSettings}
          updateSettingsHandler={updateSettingsHandler}
        />
      )}

      {/* {openXpUpdateDialog && (
        <XpSettingsDialog
          open={openXpUpdateDialog}
          onClose={() => setOpenXpUpdateDialog(false)}
          data={updateXpSettings}
          onSave={(updatedData) => {
            setLoading(true);
            put(`/admin/xp-level-settings`, {
              ...updatedData,
              settings: updatedData.settings,
            }).then(() => {
              get(`/admin/xp-level-settings`).then((response) => {
                setXpLevelSettings(response.settings);
                setLoading(false);
              });
            });
          }}
        />
      )} */}
    </>
  );
}
